const ExpandToAddOrEdit = ({ startingValue, setStartCollapsedState }) => {
    return <span className={"unselectable"} style={{ cursor: "pointer" }}
        onClick={() => { setStartCollapsedState(false) }}>
        {startingValue ? 
        <span style={{ display:"inline-block", border: "1px solid black" }}>✎ Edit &nbsp;</span> 
        : 
        <span style={{ display:"inline-block", border: "1px solid black" }}>➕ Add &nbsp;</span>}
    </span>
};

export default ExpandToAddOrEdit;